import { render } from "./FactoryAPITokenRegen.vue?vue&type=template&id=5a8aa8f7"
import script from "./FactoryAPITokenRegen.vue?vue&type=script&lang=js"
export * from "./FactoryAPITokenRegen.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__